import { render, staticRenderFns } from "./ListaUsuarios.vue?vue&type=template&id=50f1a874&scoped=true&"
import script from "./ListaUsuarios.vue?vue&type=script&lang=js&"
export * from "./ListaUsuarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f1a874",
  null
  
)

export default component.exports